import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import { openGenericModal, refreshGenericModal } from '@actions/modal';
import { showConfirmationMessage, showErrorMessage } from '@actions/messageconfirmation';

import ItemsWithTitleSubtitle from '@commons/DropdownItems/ItemsWithTitleSubtitle';

import { storeSupplierProductMapping as sspmService } from '@services/storeSupplierProductMapping';

import { getAddReferencesWithZeroModalConfig } from './modalConfiguration';

const AddReferencesWithZeroModal = (props) => {
  const {
    selectedInventories,
    handleAddReferencesWithZero,
    resetAddReferencesWithZeroModal,
    // Redux
    openGenericModal,
    refreshGenericModal,
    modal,
    showErrorMessage,
  } = props;

  const [supplierProducts, setSupplierProducts] = useState([]);
  const [selectedSupplierProducts, setSelectedSupplierProducts] = useState([]);

  useEffect(() => {
    if (isEmpty(selectedInventories)) {
      return;
    }

    const storeIds = Array.from(
      selectedInventories.reduce((acc, { storeId }) => {
        acc.add(storeId);
        return acc;
      }, new Set()),
    );

    if (isEmpty(storeIds)) {
      return;
    }

    getSSPMByStoreIds(storeIds);
  }, [selectedInventories]);

  useEffect(() => {
    const isModalOpened = get(modal, 'GenericModalBool', false);

    const params = getAddReferencesWithZeroModalConfig({
      handleAddReferencesWithZero,
      resetAddReferencesWithZeroModal,
      supplierProducts,
      selectedSupplierProducts,
      setSelectedSupplierProducts,
    });

    if (isModalOpened) {
      refreshGenericModal(params);
      return;
    }

    openGenericModal(params);
  }, [supplierProducts, selectedSupplierProducts]);

  /** METHODS */

  const getSSPMByStoreIds = async (storeIds) => {
    try {
      const supplierProducts = await sspmService.getByStoreIds(
        storeIds,
        // SP IDs to ignore
        [],
        // Filter only those available in stock
        true,
      );

      const formattedSupplierProducts = supplierProducts.map((supplierProduct) => ({
        ...supplierProduct,
        renderValue: () =>
          ItemsWithTitleSubtitle({
            title: supplierProduct.name,
            subtitle: get(supplierProduct, 'supplierName', ''),
          }),
      }));

      setSupplierProducts(formattedSupplierProducts);
    } catch {
      showErrorMessage(i18next.t('ADMIN.SUPPLIER_PRODUCTS.FETCH_ERROR'));
    }
  };

  return <div />;
};

const mapStateToProps = (state) => ({
  modal: state.modalReducer,
});

const mapDispatchToProps = (dispatch) => ({
  openGenericModal: (params) => {
    dispatch(openGenericModal(params));
  },
  refreshGenericModal: (params) => {
    dispatch(refreshGenericModal(params));
  },
  showMessage: (message, type) => {
    dispatch(showConfirmationMessage(message, type));
  },
  showErrorMessage: (message) => {
    dispatch(showErrorMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReferencesWithZeroModal);
